import { createSlice } from '@reduxjs/toolkit'

export interface PatientAreaUiState {
  isSidebarOpen: boolean
}

const initialState: PatientAreaUiState = {
  isSidebarOpen: false
}

export const patientAreaUiSlice = createSlice({
  name: 'patient-area-ui',
  initialState,
  reducers: {
    resetPatientAreaUiState: (state) => {
      state = initialState
      return state
    },
    onSidebarToggle: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen
    },
    onSidebarClose: (state) => {
      state.isSidebarOpen = false
    },
    onSidebarOpen: (state) => {
      state.isSidebarOpen = true
    }
  }
})

export const { resetPatientAreaUiState, onSidebarToggle, onSidebarClose, onSidebarOpen } = patientAreaUiSlice.actions

export default patientAreaUiSlice.reducer
